var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"page"},[_c('v-container',{staticClass:"height-100",attrs:{"fluid":""}},[_c('transition',[_c('router-view',{ref:"PageView"})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }